import { month } from "../tc/commApp/monthlyHealthReport"

export {
    month
}


// WEBPACK FOOTER //
// ./src/assets/i18n/config/tc.js